import React, { useEffect, useState } from 'react'

import { getSurveyCSV, getSurveyResultsById, getSurveyTextAnswersById } from '../../actions'
import { getChartData, getCSVData } from '../../selectors'
import { getRatingTextCount, downloadCSV } from '../../utils'

import FilterView from './FilterView'
import ChartView from './ChartView'

const SurveyDataView = ({
    survey,
    chartData,
    csvData,
    getSurveyTextAnswersById,
    page,
    setPage,
    textAnswers,
    getSurveyCSV,
}) => {
    const filterOptions = [<T>nps.admin.dashboard.filter.by.rating</T>]
    const ratingOptions = Array.from({ length: 11 }, (_, index) => `${index}`)
    const [filterRating, setFilterRating] = useState(null)
    const [filteredFeedbacks, setFilteredFeedbacks] = useState(textAnswers)
    const areAllVisible =
        (!filterRating ? survey?.textAnswersCount : getRatingTextCount(filterRating, survey)) ===
        filteredFeedbacks?.length

    useEffect(() => {
        survey && getSurveyCSV(survey.surveyId)
    }, [survey])

    useEffect(() => {
        if (page === 1) {
            setFilteredFeedbacks(textAnswers)
        }
        if (page > 1) {
            setFilteredFeedbacks(prevItems => [...prevItems, ...textAnswers])
        }
    }, [textAnswers])

    useEffect(() => {
        page > 1 &&
            (!filterRating
                ? getSurveyTextAnswersById(survey.surveyId, -1, page)
                : getSurveyTextAnswersById(survey.surveyId, filterRating, page))
    }, [page])

    const onShowMore = () => {
        setPage(page + 1)
    }

    const onChangeFilter = value => {
        setPage(1)
        setFilterRating(value)
        getSurveyTextAnswersById(survey.surveyId, value, 1)
    }

    return (
        <>
            {chartData && <ChartView surveyResults={survey} chartData={chartData} />}
            <FilterView
                filterOptions={filterOptions}
                ratingOptions={ratingOptions}
                filterRating={filterRating}
                setFilterRating={onChangeFilter}
                feedbacks={textAnswers}
                filteredFeedbacks={filteredFeedbacks}
                areAllVisible={areAllVisible}
                onShowMore={onShowMore}
                onDownloadCSV={() => downloadCSV(csvData, survey)}
            />
        </>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            chartData: getChartData,
            csvData: getCSVData,
        }),
        { getSurveyResultsById, getSurveyTextAnswersById, getSurveyCSV }
    )
)(SurveyDataView)
